import './gsk-main.css'

import { Layout } from 'antd'
import React, { Suspense } from 'react'
import { Routes } from 'react-router-dom'
import { ISingleSingOnProps } from '@gsk-tech/gsk-react-framework/dist/components/gsk-react-app/gsk-react-app'
import { ISelectedPageContainerProps } from '../../upbar/sub-components/selected-page-container/selected-page-container'
import { Upbar } from '../../upbar/upbar'
import { IReduxAction } from '@gsk-tech/gsk-react-framework'


const { Content } = Layout

export interface IHeaderMenuProps {
	title?: string
	description?: string
	loggedOutaction?: IReduxAction
}

export interface IUIProps {
	showTerminal: boolean
	selectedPageContainer: ISelectedPageContainerProps
	headerMenu: IHeaderMenuProps
	sideMenu: ISelectedPageContainerProps
	routes?: JSX.Element[]
	theme: string
}
export interface IGskMainProps {
	singleSignOn?: ISingleSingOnProps,
	ui: IUIProps
}

export const GSKMain: React.FC<IGskMainProps> = props => {

	return (
		<div className='gsk-main-div'>
			<Upbar ui={props.ui} />
			<div className='centerDiv'>
				<Layout >
					<Content
						style={{
							alignItems: 'stretch',
							display: 'flex',
							flex: 1,
							flexFlow: 'column',
							margin: 0,
						}}
					>
						<Suspense fallback={<div className="loadingScreen">
							<img src="logo192.png" alt="GSK Logo" />
							<br />
							<br />
							<span>Loading...</span>
						</div>}>
							<Routes>{props.ui.routes}</Routes>
						</Suspense>
					</Content>
				</Layout>
			</div>
			<div className='footer'>
				<div className="innerFooter">
					<span className="version">
						<label> R&D Data Storage</label> - <span style={{ fontSize: "10px" }}>Version : {window._env_.REACT_APP_FULL_VERSION ?? "1.0.0"}</span>
					</span>
				</div>
			</div>

		</div>
	)
}
